import { types } from './BranchAction';
import { types as organisationTypes } from '../../OrganisationAction';
import { mergeListReceiveState } from '../../../../utils/listFetchState';

const initialState = { loadingBranches: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case organisationTypes.SWITCH_ORGANISATION:
      return { ...initialState };
    case types.REQUEST_BRANCHES:
      return { ...state, loadingBranches: true };
    case types.RECEIVE_BRANCHES:
      return {
        ...state,
        loadingBranches: false,
        branches: mergeListReceiveState(action.branches, state.branches),
      };
    default:
      return state;
  }
};
